import { render, staticRenderFns } from "./ConfigureSubModality.vue?vue&type=template&id=9417aaf4"
import script from "./ConfigureSubModality.vue?vue&type=script&lang=js"
export * from "./ConfigureSubModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports